var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"font-lato"},[_c('v-icon',{staticClass:"marker-external",attrs:{"size":"16"}},[_vm._v("$vuetify.icons.charity")]),_c('span',{staticClass:"small marker-external"},[_vm._v("This is an external contribution")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }